<template>
  <BaseForm
    :key="customerId || 'new'"
    :title="formTitle"
    :formData="customerData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue'; // Make sure the path is correct
import axios from 'axios'; // Ensure axios is imported

export default {
  components: {
    BaseForm
  },
  props: {
    customerId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      customerName: '',
      customerData: {
        name: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        zip_code: '',
        office_phone: '',
        contact_person: '',
        cell_phone: '',
        fax: '',
        email: ''
      },
      fields: [
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'address_line1', label: 'Address Line 1', type: 'text' },
        { model: 'address_line2', label: 'Address Line 2', type: 'text' },
        { model: 'city', label: 'City', type: 'text' },
        { model: 'state', label: 'State', type: 'text' },
        { model: 'zip_code', label: 'Zip Code', type: 'number' },
        { model: 'office_phone', label: 'Office Phone', type: 'text' },
        { model: 'contact_person', label: 'Contact Person', type: 'text' },
        { model: 'cell_phone', label: 'Cell Phone', type: 'text' },
        { model: 'fax', label: 'Fax', type: 'text' },
        { model: 'email', label: 'Email', type: 'text' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.customerId ? `Edit: ${this.customerName || 'Customer'}` : 'Add Customer';
    },
    submitUrl() {
      return this.customerId ? `/api/v1/customer/customers/${this.customerId}/` : '/api/v1/customer/customers/';
    },
    method() {
      return this.customerId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.customerId) {
      this.loadCustomerData();
    }
  },
  methods: {
    loadCustomerData() {
      axios.get(this.submitUrl).then(response => {
        this.customerData = response.data;
        this.customerName = this.customerData.name
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Customer saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError() {
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving customer!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
